import { Hero } from './hero.model';

/**
 * The structure of the Walk object
 */
export class Walk {
  id = '';
  titel = '';
  korteTitel = '';
  locatieTekst = '';
  afstandTekstvorm = '';
  naam = '';
  path = '';
  url = '';
  stickerTekst = '';
  hero = new Hero();
  afstanden = 0;
  geschiktVoor: string[] = [];
  soort: string[] = [];

  get tileTitel(): string {
    return this.korteTitel || this.titel;
  }
}
